/**
 * Módulo único de tratamento de CNPJ (cadastro-organico).
 *
 * CNPJ alfanumérico (jul/2026): os 12 primeiros caracteres podem conter
 * letras A-Z; os 2 dígitos verificadores continuam numéricos. Máscara
 * XX.XXX.XXX/XXXX-XX, letras sempre em maiúsculo. Nunca usar
 * replace(/\D/g) em CNPJ (apaga as letras).
 */

const SOMENTE_ALFANUMERICO = /[^0-9A-Za-z]/g;
const FORMATO_VALIDO = /^[0-9A-Z]{12}[0-9]{2}$/;
const TODOS_IGUAIS = /^(.)\1{13}$/;

export function normalizarCnpj(value) {
  return String(value ?? '').replace(SOMENTE_ALFANUMERICO, '').toUpperCase();
}

export function mascararCnpj(value) {
  const c = normalizarCnpj(value).slice(0, 14);
  let out = '';
  for (let i = 0; i < c.length; i++) {
    if (i === 2 || i === 5) out += '.';
    else if (i === 8) out += '/';
    else if (i === 12) out += '-';
    out += c[i];
  }
  return out;
}

function valorCaractere(ch) {
  return ch.charCodeAt(0) - 48;
}

function calcularDV(base) {
  let soma = 0;
  let peso = 2;
  for (let i = base.length - 1; i >= 0; i--) {
    soma += valorCaractere(base[i]) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}

export function validarCnpj(value) {
  const c = normalizarCnpj(value);
  if (c.length !== 14) return false;
  if (!FORMATO_VALIDO.test(c)) return false;
  if (TODOS_IGUAIS.test(c)) return false;
  if (calcularDV(c.slice(0, 12)) !== Number(c[12])) return false;
  if (calcularDV(c.slice(0, 13)) !== Number(c[13])) return false;
  return true;
}
